import Vue from 'vue'
import VueRouter from 'vue-router'
import Main from '../views/Main.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'main',
    component: Main
  },
  {
    path: '/members/sso-login',
    name: 'sso-login',
    component: () => import('@/components/members/sso-login.vue')
  },
  {
    path: '/studios/sign-in',
    name: 'studios-sign-in',
    component: () => import('@/components/studios/Auth/Login.vue')
  },
    {
      path: '/members/account-activation',
      component: () => import('@/views/success.vue'),
      children: [
            {
                path: '/members/account-activation',
                name: 'account-activation',
                component: () => import('@/components/success/account-activation.vue')
            },
            {
                path: '/members/reset-password-sent',
                name: '/members/reset-password-sent',
                component: () => import('@/components/success/ResetPasswordSent.vue')
            },
            {
                path: '/members/confirm-reset-password-success',
                name: '/members/confirm-reset-password-succes',
                component: () => import('@/components/success/ResetPasswordConfirm.vue')
            },
            {
                path: '/members/sign-up-sent',
                name: '/members/sign-up-sent',
                component: () => import('@/components/members/auth/SignUpConfirm.vue'),
            },
            {
                path: '/members/sign-up/verification-completed',
                name: '/members/sign-up/verification-completed',
                component: () => import('@/components/success/verificationCompleted.vue'),
            },
        ]
    },
  {
    path: '/studios/dashboard',
    component: () => import('@/views/Home.vue'),
    meta: {
      requiredStudio: true
    },
    children: [
    {
        path: '/studios/dashboard',
        name: 'dashboard',
        component: () => import('@/components/studios/Dashboard/Dashboard.vue')
    },
    {
      path: '/studios/members/new-member',
      name: 'new-member',
      component: () => import('@/components/studios/RegisterMember.vue')
    },
      {
          path: '/studios/members',
          name: 'view-members',
          component: () => import('@/components/studios/Members/viewAllMembers.vue')
      },
    {
        path: '/studios/unapproved-members',
        name: 'unapproved-members',
        component: () => import('@/components/studios/Members/unapprovedMembers.vue')
    },
      {
          path: '/studios/members/check-in',
          name: 'check-in',
          component: () => import('@/components/studios/Members/checkIn/checkInLayout.vue')
      },
      {
          path: '/studios/statistics/members',
          name: 'member-statistics',
          component: () => import('@/components/studios/Statistics/membersStatistics.vue')
      },
      {
          path: '/studios/statistics/guests',
          name: 'guest-statistics',
          component: () => import('@/components/studios/Statistics/guestsStatistics.vue')
      },
      {
          path: '/studios/partner-studios',
          name: 'partner-studios',
          component: () => import('@/components/studios/Statistics/partnerStudios.vue')
      },
      {
          path: '/studios/inactive-members',
          name: 'inactive-members',
          component: () => import('@/components/studios/Members/inactiveMembers.vue')
      },
  ]
  },
    {
        path: '/members/sign-in',
        name: 'members-sign-in',
        component: () => import('@/views/memberSign.vue'),
        children: [
            {
                path: '/members/sign-in',
                name: 'members-sign-in',
                component: () => import('@/components/members/auth/login.vue'),
            },
            {
                path: '/members/sign-up',
                name: 'members-sign-up',
                component: () => import('../components/members/auth/SignUp.vue')
            }
        ]
    },
    {
        path: '/members/reset-password',
        name: '/members/resets',
        component: () => import('@/views/resets.vue'),
        children: [
            {
                path: "/members/reset-password",
                name: '/members/reset-password',
                component: () => import('@/components/members/auth/ResetPassword.vue')
            },
            {
                path: "/members/confirm-reset-password",
                name: '/members/confirm-reset-password',
                component: () => import('@/components/members/auth/ResetPasswordConfirm.vue')
            }
        ]
    },
    {
        path: "/members/dashboard",
        component: () => import('@/views/Members/Home.vue'),
        meta: {
            requiredClient: true
        },
        children: [
            {
                path: '/members/dashboard',
                name: 'member-dashboard',
                component: () => import('@/components/members/Dashboard/Dashboard.vue')
            },
            {
                path: '/members/studio-finder',
                name: 'studio-finder',
                component: () => import('@/components/members/Dashboard/StudioFinder.vue')
            },
            {
                path: '/members/studio-finder/:slug',
                name: 'members-studio-page',
                component: () => import('@/components/members/MembersStudioPage.vue'),
                props: true,
            },
            {
                path: '/members/view-my-visits',
                name: 'view-my-visits',
                component: () => import('@/components/members/Dashboard/ViewMyVisits.vue')
            },
            {
                path: '/members/faq',
                name: 'faq',
                component: () => import('@/components/members/Dashboard/Faq.vue')
            },
            {
                path: '/members/privacy',
                name: 'privacy',
                component: () => import('@/components/members/StaticPages/Privacy.vue')
            },
            {
                path: '/members/imprint',
                name: 'imprint',
                component: () => import('@/components/members/StaticPages/Imprint.vue')
            },
            {
                path: '/members/terms-of-use',
                name: 'terms-of-use',
        component: () => import('@/components/members/StaticPages/TermsOfUse.vue'),
        alias: ['/members/conditions']
            },
            {
                path: '/members/change-password',
                name: 'members-change-password',
                component: () => import('@/components/members/ChangePassword.vue')
            }
        ]
    },

];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
})







router.beforeEach((to, from, next) => {
        // if (!to.matched.length) {
        //     next('/404');
        // } else {
        //     next();
        // }
        //
        if(to.matched.some(record => record.meta.requiredStudio)) {
            const STUDIO_TOKEN = localStorage.getItem('studio_jwt');
            if (STUDIO_TOKEN) {
                next()
                return
            }
            next('/studios/sign-in')
        }
        else if(to.matched.some(record => record.meta.requiredClient)) {
            const CLIENT_TOKEN = localStorage.getItem('client_jwt');
            if (CLIENT_TOKEN || to.name === 'privacy' || to.name === 'imprint' || to.name === 'terms-of-use') {
                next()
                return
            }
            next('/members/sign-in')
        }
        else {
            next()
        }
})

export default router



